import React, { useEffect, useState } from "react";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import EachProject from "./EachProject";

const Projects = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  const [projectsList, setProjectsList] = useState([]);
  const [loading, setLaoding] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("db.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setProjectsList(data);
        setLaoding(false); // Assuming your API response has a 'projects' field
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error states, e.g., set error state or display error message
      }
    };

    fetchData();

    // Cleanup function, if needed
    return () => {
      // Cleanup logic, if needed
    };
  }, []);

  // console.log(projectsList);
  return (
    <div>
      <section className="min-h-[863px]">
        <div className="container px-6 py-10 mx-auto">
          <h1
            data-aos="zoom-in"
            data-aos-duration="1500"
            className="text-3xl font-semibold text-center text-white capitalize lg:text-4xl "
          >
            Projects
          </h1>
          {loading ? (
            <span className="loading loading-ring loading-lg"></span>
          ) : (
            <div className="grid grid-cols-1 gap-3 mt-8 xl:mt-12 mb-6 xl:gap-12 lg:grid-cols-3">
              {projectsList.map((each) => (
                <EachProject key={each.id} each={each}></EachProject>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;
